import { render, staticRenderFns } from "./RotationalMenuItemModal.vue?vue&type=template&id=e84dbc3e"
import script from "./RotationalMenuItemModal.vue?vue&type=script&lang=ts"
export * from "./RotationalMenuItemModal.vue?vue&type=script&lang=ts"
import style0 from "./RotationalMenuItemModal.vue?vue&type=style&index=0&id=e84dbc3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports